import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import type {
  TransmitterFormData,
  TransmitterV2Document,
} from '../../types';

interface DetailsSectionProps {
  formData: TransmitterFormData;
  setField: <K extends keyof TransmitterFormData>(key: K, value: TransmitterFormData[K]) => void;
  transmitter: TransmitterV2Document;
}

export function DetailsSection({
  formData,
  setField,
}: DetailsSectionProps) {
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-muted-foreground uppercase tracking-wider">
        Details
      </h3>

      {/* Description */}
      <div className="grid grid-cols-[140px_1fr] items-start gap-2">
        <Label className="pt-2">Description</Label>
        <Textarea
          value={formData.description}
          onChange={(e) => setField('description', e.target.value)}
          rows={4}
        />
      </div>
    </div>
  );
}
